// const coverPhoto = (pid) => `/api/photos/cover_photo/${pid}`
const API = process.env.NEXT_PUBLIC_IMAGE_SERVICE
const coverPhoto = (pid) => `${API}/photo/${pid}/cover`

export default coverPhoto